const experiences = [
  {
    id: 1,
    position: 'Software Developer (Part-time)',
    timestamp: 'July 2023 - Present',
    org: 'Advance Studio',
    location: 'Brisbane, Queensland, Australia',
    skills: 'Vue, CSS, Unity, C#',
    desc: [
      'Currently contributing remotely to a small studio, collaborating with a senior software engineer and international artists and designers (from Vietnam, Japan and Canada) on the mobile and desktop game <a href="https://gamejolt.com/games/advance-chess/998256" target="_blank"> Battle of Lords: Advance Chess.</a>',
      'Responsible for implementing complex chess movements and animations using <b> Unity/C# </b> programming techniques.',
      'Working on UI/UX enhancements and game state management logic for a more engaging player experience.',
      'Building a <b> VueJS </b> <a href="https://battle-of-lords-advance-chess.netlify.app/" target="_blank"> landing page </a> with a visually aligned game interface (page is still updating).',
    ],
  },
  {
    id: 2,
    position: 'Software Developer',
    timestamp: 'April 2023 - October 2023',
    org: 'Beyond Studio',
    location: 'Hanoi, Vietnam (Remote)',
    skills: 'HTML, CSS, JavaScript, Unity, C#',
    desc: [
      'Developed animations and features like coin tossing, card movements, and spawning for the <a href="https://www.youtube.com/watch?v=WTUkFY_wgHg" target="_blank"> Epoch2140 </a>’s sport-style Trading Card game and created the game’s <a href="https://www.youtube.com/watch?v=UkzMu5wFNSg" target="_blank"> Interactive Booth </a> with <b> Unity/C# </b>. Therefore, developed the <a href="https://epoch2140.com/" target="_blank"> Epoch 2140’s landing page </a>  using <b> HTML/CSS </b> and <b> JavaScript </b>.',
      'Developed RPG-style elements like a third-person controller, Ready Player Me for character selection, and a Pokemon-inspired horse-catching system using <b> Unity/C# </b> for the <a href="https://www.metahorseunity.io/#gameplay-1" target="_blank"> MetaHorse </a>s horse racing game.',
    ],
  },
  {
    id: 3,
    position: 'Software Developer (Internship)',
    timestamp: 'September 2021 - March 2022',
    org: 'Premier Ducts Pty Ltd',
    location: 'Brisbane, Queensland, Australia',
    skills: 'Unity, C#, Xamarin',
    desc: [
      'Designed and implemented the front-end and user experience for an internal application utilised by duct workers in the workshop.',
      'Created application features, including creating new stations using <b>Unity Engine</b>, <b>C#</b>, and also <b>Xamarin</b>.',
    ],
  },
  {
    id: 4,
    position: 'Software Developer (Internship)',
    timestamp: 'November 2017 - January 2018',
    org: 'ACB - Asia Commercial Bank',
    location: 'Ho Chi Minh City, Vietnam',
    skills: 'Python',
    desc: [
      'Developed a small service system (customer paying bills process) with <b> Python</b>.',
    ],
  },
];
export default experiences;
